<template>
  <div>
    <!-- Main Row -->
    <div class="row">
      <div class="col-md-12">
        <Card :title="'Detail Peringatan Obat'">
          <template v-slot:body>
            <div class="row align-items-center">
              <!-- Profile Image -->
              <div class="col-md-4">
                <div
                  class="d-flex justify-content-center align-items-center image-container"
                >
                  <div style="height: 350px; width: 350px; position: relative">
                    <img
                      class="image"
                      src="/images/undraw_medical_care_movn.svg"
                      @load="onImageLoad()"
                    />
                  </div>
                </div>
              </div>

              <!-- Table Data -->
              <div class="col" v-if="imgLoaded != false">
                <table class="table mb-3">
                  <tr>
                    <td><strong>Nama Obat</strong></td>
                    <td>{{ data.medicine_name }}</td>
                  </tr>
                  <tr>
                    <td><strong>Jenis Stok</strong></td>
                    <td>
                      <span v-if="data.stock_in_out == 0">Stok Masuk</span>
                      <span v-if="data.stock_in_out == 1">Stok Keluar</span>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Kuantitas</strong></td>
                    <td>{{ data.quantity }}</td>
                  </tr>
                  <tr>
                    <td><strong>Sisa Stok</strong></td>
                    <td>{{ data.remaining_stock }}</td>
                  </tr>
                  <tr>
                    <td><strong>Harga</strong></td>
                    <td>{{ data.price ? data.price : "-" }}</td>
                  </tr>
                  <tr>
                    <td><strong>Batch No</strong></td>
                    <td>{{ data.batch_no ? data.batch_no : "-" }}</td>
                  </tr>
                  <tr>
                    <td><strong>Kedaluwarsa</strong></td>
                    <td>{{ data.expired ? data.expired : "-" }}</td>
                  </tr>
                  <tr>
                    <td><strong>Catatan</strong></td>
                    <td>{{ data.notes ? data.notes : "-" }}</td>
                  </tr>
                </table>
                <button
                  @click="
                    $router.push({
                      name: 'maintain-stock-edit',
                      params: { id: data.id },
                    })
                  "
                  class="btn mx-1 btn-success"
                >
                  <i class="far fa-fw fa-edit"></i> Edit
                </button>
                <button class="btn mx-1 btn-danger">
                  <i class="far fa-fw fa-trash-alt"></i> Hapus
                </button>
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>

    <!-- List Medicine Stock History -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <!-- <b-alert
              show
              variant="light"
              class="alert alert-custom alert-white alert-shadow fade show gutter-b"
            >
              <div class="alert-icon">
                <span class="svg-icon svg-icon-lg">
                  <inline-svg src="/media/svg/icons/Tools/Compass.svg" />
                </span>
              </div>
              <div class="alert-text">
                Berikut adalah Riwayat Stok Obat <b>{{ data.medicine_name }}</b>
              </div>
            </b-alert> -->
            <span class="svg-icon svg-icon-lg">
              <inline-svg src="/media/svg/icons/Tools/Compass.svg" />
            </span>
            <span class="mb-6"
              >Riwayat Stok Obat <b>{{ data.medicine_name }}</b></span
            >
            <b-table
              striped
              hover
              :items="history"
              :fields="fields"
              class="mt-6"
              :style="'white-space: nowrap'"
              responsive="md"
            >
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '20%' : '' }"
                />
              </template>
              <template #cell(stock_in_out)="data">
                <!-- <img v-if="data.item.stock_in_out == 0" src="/media/svg/icons/Navigation/Arrow-up.svg"> -->
                <!-- <img v-if="data.item.stock_in_out == 1" src="/media/svg/icons/Navigation/Arrow-down.svg"> -->
                <i
                  v-if="data.item.stock_in_out == 0"
                  class="fas fa-arrow-down"
                  style="color: green"
                  v-b-tooltip.hover
                  title="Stok Masuk"
                ></i>
                <i
                  v-if="data.item.stock_in_out == 1"
                  class="fas fa-arrow-up"
                  style="color: red"
                  v-b-tooltip.hover
                  title="Stok Keluar"
                ></i>
              </template>
              <template #cell(price)="data">
                <span v-if="data.item.price == 0.0"></span>
                <span v-if="data.item.price != 0.0">{{ data.item.price }}</span>
              </template>
              <!-- <template #cell(actions)="data">
                <b-button
                  size="sm"
                  class="mr-1 btn-info"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="
                    $router.push({
                      path: '/medicine/maintain-stock-detail/' + data.item.id,
                    })
                  "
                >
                  <i class="fas fa-eye px-0"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="
                    $router.push({
                      path: '/medicine/maintain-stock-edit/' + data.item.id,
                    })
                  "
                >
                  <i class="fas fa-edit px-0"></i>
                </b-button>
              </template> -->
            </b-table>
            <b-pagination
              v-if="history.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"
            ></b-pagination>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import module from "@/core/modules/CrudModule.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "Detail",

  components: {
    Card,
  },

  data() {
    return {
      imgLoaded: false,
      data: [],
      history: [],
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 1,
      // Table
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        {
          key: "medicine_name",
          label: "Obat",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        {
          key: "stock_in_out",
          label: "Jenis Stok",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        {
          key: "quantity",
          label: "Kuantitas",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        {
          key: "remaining_stock",
          label: "Stok sisa",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        {
          key: "price",
          label: "Harga",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        {
          key: "vendor_name",
          label: "Penyedia",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        {
          key: "batch_no",
          label: "Batch No",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        {
          key: "created_at_display",
          label: "Tanggal Input",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        {
          key: "created_by_name",
          label: "Penginput",
          sortable: true,
          thClass: "th-list-medicines",
          tdClass: "td-list-medicines",
        },
        // { key: "actions", label: "Aksi" },
      ],
    };
  },

  methods: {
    onImageLoad() {
      this.imgLoaded = true;
    },

    async deleteData() {
      let result = await module.delete("medicines/" + this.$route.params.id);
      // If Deleted
      if (result) {
        // Redirect To List
        this.$router.push("/medicine/maintain-stock");
      }
    },

    async get() {
      this.data = await module.get("medicine-stocks/" + this.$route.params.id);
      // this.getMedicineHistory(this.data.medicine_id)
      this.pagination(this.data.medicine_id);
      // If Data Not Found
      if (this.data == null) {
        // Redirect To List
        this.$router.push("/medicine/maintain-stock");
      }
    },

    pageOnClick(evt, page) {
      evt.preventDefault();
      this.currentPage = page;
      this.pagination();
    },

    async pagination(medicine_id) {
      let response = await module.paginate(
        "medicine-stocks-history/" + medicine_id
      );
      let pagination = response.meta.pagination;
      this.history = response.data;
      this.totalRows = pagination.total;
    },

    async getMedicineHistory(medicine_id) {
      this.history = await module.get("medicine-stocks-history/" + medicine_id);
      console.log("history", this.history);
      // If Data Not Found
      if (this.history == null) {
        // Redirect To List
        this.$router.push("/medicine/maintain-stock");
      }
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Obat", route: "/medicine/list" },
      { title: "Stok Obat", route: "/medicine/maintain-stock" },
      { title: "Detail Stok Obat" },
    ]);

    this.get();
  },
};
</script>

<style>
/* Dynamic Size Image */
.image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
</style>